<template>
  <div class="grid lg:grid-cols-11 row-gap-12 lg:row-gap-4 items-center">
    <div class="col-span-6 text-text-secondary text-sm font-medium flex items-center leading-relaxed -mt-1">
      <IconLockOpen class="text-icon mr-6"/>
      <div>
        <div>{{ $t('lockedText') }}</div>
        <span class="text-sm text-red font-normal
            border-b border-red border-dashed border-opacity-30
            transition duration-200
            hover:border-opacity-100 cursor-pointer"
              @click="showTip = !showTip">{{ $t('forgotText') }}</span>
      </div>
    </div>
    <div class="col-span-5 grid grid-cols-7 col-gap-8">
      <PasswordInput class="col-span-4" v-model.trim="$v.pin.$model"
                     :label="$t('pinLabel')"
                     :password-reveal="true"
                     :error="$v.pin.$error"
                     @keydown.enter="unlockSettings">
        <template slot="errors">
          <div class="error" v-if="!$v.pin.required">{{ $t('errors.required') }}</div>
        </template>
      </PasswordInput>
      <BaseButton class="col-span-3"
                  theme="red"
                  @click="unlockSettings"
                  :disabled="saving">
        {{ $t('applyBtn') }}
      </BaseButton>
    </div>
    <div class="col-span-11 pl-12" v-if="showTip">
      <p class="text-sm text-text-ternary mb-4 leading-relaxed" v-html="$t('pinTip')"></p>
      <BaseButton theme="default" size="sm"
                  :disabled="PINUpdating"
                  @click="updatePIN">
        {{ $t('restorePin') }}
      </BaseButton>
    </div>
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import BaseInput from "@/components/UI/BaseInput/BaseInput";
import BaseButton from "@/components/UI/BaseButton";
import IconLockOpen from "@/components/icons/IconLockOpen";
import PasswordInput from "@/components/UI/BaseInput/PasswordInput";
import {mapActions, mapMutations} from "vuex";

export default {
  name: "PasswordGuardPIN",
  components: {
    PasswordInput,
    IconLockOpen,
    BaseButton,
    BaseInput,
  },
  props: {
    saving: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      pin: '',
      showTip: false,
      PINUpdating: false
    }
  },
  validations: {
    pin: {
      required,
    },
  },
  methods: {
    ...mapActions('cabinet/user', ['setNewSettingsPIN']),
    unlockSettings() {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.saving) {
        this.$emit('unlock', {pin: this.pin})
      }
    },
    async updatePIN() {
      this.PINUpdating = true;
      const res = await this.setNewSettingsPIN()
      if (res.body.success) {
        this.$toasted.success(this.$t('pinSetSuccess'))
        this.PINUpdating = false;
      } else {
        this.PINUpdating = false;
      }
    }
  },
  i18n: {
    messages: {
      en: {
        lockedText: 'To change the settings you need to specify your PIN',
        pinLabel: 'Your PIN code',
        applyBtn: 'Submit',
        forgotText: 'Forgot your pin?',
        pinTip: 'We sent a PIN in a welcome email after registering with MoneyKeeper. <br> If it\'s gone for a long time, we can send a new one.',
        restorePin: 'Send new PIN to e-mail',
        pinSetSuccess: 'New PIN code sent on your e-mail'
      },
      ru: {
        lockedText: 'Чтобы изменить настройки нужно указать ваш PIN',
        pinLabel: 'Ваш PIN код',
        applyBtn: 'Подтвердить',
        forgotText: 'Забыли пин?',
        pinTip: 'Мы отправили PIN в приветственном письме после регистрации в MoneyKeeper.<br> Если его давно уже нет или вам просто лень его искать, мы можем отправить новый.',
        restorePin: 'Отправить новый PIN на почту',
        pinSetSuccess: 'Новый PIN отправлен вам на почту'
      }
    }
  }
}
</script>